// Module
var code = "<!-- ko with: _component --> <!-- ko template: {name: $data.GetTemplateName.bind($data), afterRender: $data.AfterRender.bind($data)} --> <!-- /ko --> <!-- /ko -->";
// Exports
export default code;